var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ApproveSelector"},[_c('el-select',{attrs:{"value":_vm.valueUse,"placeholder":"选择审批状态"},on:{"input":_vm.change}},[(_vm.isFilter)?_c('el-option',{attrs:{"label":"所有状态","value":0}}):_vm._e(),_vm._l((_vm.status),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.label,"value":item.id}})})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }